export function set_focus(focus, el) {
    if (focus && el) {
        el.focus();
    }
}
